var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DynamicScroller',{ref:"scroller",staticClass:"app-large-scroll",attrs:{"items":_vm.items,"min-item-size":_vm.minItemSize,"buffer":_vm.buffer,"key-field":_vm.keyField},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
var index = ref.index;
var active = ref.active;
return [_c('DynamicScrollerItem',{attrs:{"item":item,"active":active,"size-dependencies":_vm.sizeDependencies(item),"data-index":index,"emit-resize":false,"watch-data":false}},[_vm._t("default",null,{"item":item,"index":index})],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }